import React, { Component } from "react";
import ReactDOM from 'react-dom';
import FileTab from "./FileTab";
import axios from "axios"
import { format } from "date-fns";
import Pagination from "./Pagination";
import { LangContext } from "../LangContext.jsx";

class FilePanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    const current_tab = props.current_tab == 'locales/' ? 'locals' : 'files';
    this.state = {
      activeTab: current_tab,
      filters: {},
      searchActive: false,
      pagination: { files: 1, locals: 1, page: 1 },
      files: { files: [], locals: [], total: { locals: 0, files: 0 } },
    };
    this.filterOptions = [
      'pdf', 'svg', 'jpg',
      'jpeg', 'png', 'xml',
      'xls', 'xlsx', 'doc',
      'docx', 'ppt', 'pptx',
      'zip'
    ];
  }

  getFiles = async () => {
    const request = await axios.get('/api/files/grouped');
    this.setState({ files: request.data });
  };

  handleSwitch = (key) => {
    this.setState((prev) => ({ activeTab: key, pagination: { ...prev.pagination, page: 1 } }), () => {
      this.updateCurrentPage(1, 1);
    });
  };

  getFilteredFiles = async () => {
    const { filters, activeTab, pagination } = this.state;
    const mixFilter = {
      ...filters,
      pageOneTime: activeTab === 'files' ? pagination.files : 1,
      pageRecurrent: activeTab === 'locals' ? pagination.locals : 1,
    };
    const query = new URLSearchParams();
    Object.keys(mixFilter).forEach((key) => {
      if (mixFilter[key] !== '' && mixFilter[key] !== 1) {
        query.append(key, mixFilter[key]);
      }
    });
    query.append('page', pagination.page);
    const qs = query.toString();
    if (pagination.page !== undefined) {
      const request = await axios.get(`/api/files/grouped?${qs}`);
      this.setState({ files: request.data, searchActive: true });
    } else {
      this.setState({ searchActive: false });
      this.getFiles();
    }
  };

  handleFiltering = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({ filters: { ...prev.filters, [name]: value } }));
  };

  updateCurrentPage = (tab, page) => {
    this.setState((prev) => ({ pagination: { ...prev.pagination, page } }));
  };

  componentDidMount() {
    this.getFilteredFiles();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.filters !== this.state.filters ||
      prevState.pagination.page !== this.state.pagination.page ||
      prevState.activeTab !== this.state.activeTab
    ) {
      this.getFilteredFiles();
    }
  }

  checkImageExtension = (path) =>{
    const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
    const extension = path.split('.').pop().toLowerCase();
    return validExtensions.includes(extension);
  }

  handleDelete = (id) => {
    swal.fire({
        text: "¿Desea continuar con el borrado?",
        showCancelButton: true,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        customClass: {
            confirmButton: "btn font-weight-bold btn-primary",
            cancelButton: "btn font-weight-bold btn-danger"
        }
    }).then((result) => {
        if (result.isConfirmed) {
            this.deleteFile(id);
        }
    });
  }
  deleteFile = async (id) => {

    window.blockUI();
    await axios.delete(
        '/providers/file/delete/' + id,
        {
            "headers": {
                "content-type": "application/json",
            },
        }
    ).then((response) => {
        window.unblockUI();
        KTUtil.btnRelease(KTUtil.getById('btnDelete'));

        swal.fire({
            text: 'Se ha eliminado el archivo',
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Aceptar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary"
            },
            timer: 3000
        }).then(function(result) {
            window.location.href = '/files?tab=locales';
        });
    }).catch((error) => {
        window.unblockUI();
        const message = getErrorsMessage(error);
        KTUtil.btnRelease(KTUtil.getById('btnDelete'));

        swal.fire({
            text: message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Aceptar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary"
            }
        });
    });
  }
  getFileImage = (id,filename) =>{
    let extension_file = filename.split('.').pop()
    var type    = 'iframe';
    var images  = ['jpg', 'jpeg', 'png', 'gif','svg'];
    if(images.includes(extension_file.toLowerCase())){
        type = 'image';
		$.magnificPopup.open({
			items: {
				src: '/files/provider/'+ id
			},
			type: type
		});
    }
}

  getFileDossier = (id,filename) =>{
	
    let extension_file = filename.split('.').pop()
    var type    = 'iframe';
    var images  = ['jpg', 'jpeg', 'png', 'gif','svg'];
    if(images.includes(extension_file.toLowerCase())){
        type = 'image';
		$.magnificPopup.open({
			items: {
				src: '/files/'+ id
			},
			type: type
		});
    }else{
		var iframe = document.getElementById('document-iframe');
		var url = '/previews/'+id;
		iframe.src = url;
		window.blockUI();
        const timeout = 8000;
        let loadEventFired = false;
        const reloadURLIfLoadNotFired = () => { 
            if (!loadEventFired) {
                iframe.src = url;
            }
        };

        const timeoutID = setTimeout(reloadURLIfLoadNotFired, timeout);

        iframe.addEventListener('load', function() {
        loadEventFired = true;
        clearTimeout(timeoutID);  
        window.unblockUI();
        
        axios.post('/previews/' + id, {
            _method: 'delete'
        });
        $('#visor-modal').modal('show');
        });
	}
    
}

  render() {
    const { lang } = this.context;
    const { files, activeTab, pagination, searchActive } = this.state;
    return (
    <>
    <div className="row">
		<div className="col-1 align-self-center ">
			<p className="font-weight-bold pt-2">{lang.get('messages.filtrar_por')}</p>
		</div>

		<div className="col-3">
			<select
			onChange={this.handleFiltering}
			name="extension"
			className="form-control form-control-solid bg-white">
			<option value="">Seleccionar...</option>
			{this.filterOptions.map(option => (
				<option value={option} key={option}>{option.toUpperCase()}</option>
			))}
			</select>
		</div>

		<div className="col-4">
		</div>

		<div className="col-4">
			<div className="input-icon">
			<input
				onChange={this.handleFiltering}
				name="search"
				type="text"
				className="form-control"
				placeholder="Buscar documentos" />
			<span>
				<i className="flaticon2-search-1 text-primary icon-md"></i>
			</span>
			</div>
		</div>
    </div>

        {searchActive &&
			<h5 className="text-dark font-weight-bold my-5">
				<small className="text-muted font-weight-bold">{lang.get('messages.resultados_de_la_busqueda')}:</small>
				&nbsp; {files.total.locals + files.total.files} &nbsp;
				<small className="text-muted font-weight-bold">{lang.get('messages.documentos_encontrados')}</small>
			</h5>
        }

        <div className="card card-custom gutter-b my-5">
            <div className="card-body">
                <ul className="nav nav-tabs nav-tabs-line">
                    <li className="nav-item">
                        <a
                            onClick={() => this.handleSwitch('files')}
                            style={{cursor: 'pointer'}}
                            className={`nav-link ${activeTab =='files' ? "active" : ""}`}
                            data-toggle="tab">
                            {lang.get('messages.archivos_solicitados')} &nbsp;<span className="badge badge-secondary">{files.total.files}</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            onClick={() => this.handleSwitch('locals')}
                            className={`nav-link ${activeTab =='locals' ? "active" : ""}`}
                            style={{cursor: 'pointer'}}
                            data-toggle="tab" >
                            {lang.get('messages.mis_archivos')} &nbsp;
                            <span className="badge badge-secondary">{files.total.locals}</span>
                        </a>
                    </li>
                </ul>
                <div className="tab-content mt-5" id="myTabContent">
                <div className="tab-pane fade show active" id="kt_tab_pane_1" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                <table className="table table-borderless m-0 table-valign">
                    <thead >
                        <tr>
                            <th colSpan="2">{lang.get('messages.nombre_del_archivo')}</th>
                            {activeTab == 'files' ? <th>{lang.get('messages.expediente')}</th> : null }
                            {activeTab == 'files' ? <th>{lang.get('messages.frecuencia')}</th> : null }
                            <th>{lang.get('messages.fecha')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colSpan="6"></td>
                    </tr>
                    {files[activeTab]?.map((p, i) => { 
                    return  <tr>
                    {activeTab == 'locals'  &&
                        <td>
                            <img src={"/assets/img/" + window.getMimeSVG( p.path)} />
                        </td>
                    }
                    {activeTab == 'files'  &&
                        <td>
                            <img src={"/assets/img/" + window.getMimeSVG(p.file.extension!=undefined && p.file.extension.length>0 ? p.file.extension : p.file.path)} />
                        </td>
                    }
                    {activeTab == 'locals'  &&
                        <td>
                            <div className="font-weight-bold">{p.title}</div>
                        </td>
                    }
                    { activeTab == 'files' &&
                    <>
                        <td>
                            <div className="font-weight-bold">{p.document.title} </div>
                        </td>
                        <td>
                            <div className="font-weight-bold"> {p.dossier.title} </div>
                            <div className="text-dark-50"> {p.dossier.type.title} </div>
                        </td>
                    </>
                    }
                    { activeTab == 'files' &&
                        <td>
                            <div className="font-weight-bold">
                            { ( p.document.frequency == 'once' ? 'Único': 'Recurrente') }
                            </div>
                        </td>
                    }
                    <td>{format(new Date(p.created_at), 'dd/MM/yyyy')}</td>
                    { activeTab == 'files' &&
                        <td className="text-right">
                             
                            {p.file && p.file.extension !== 'zip' &&
                            <a data-toggle="modal" onClick={() => this.getFileDossier(p.id,p.file.extension) } data-target={'#modal'+p.file.id} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                <i className="flaticon2-file text-primary icon-sm"></i>
                            </a>
                            }
                            <a href={'files/' +p.id} download target="_blank" className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                <i className="flaticon2-download text-primary"></i>
                            </a>
                            {p.person_document_statuses_id == 5 && 
                            <a href={"/document_dossier/"+p.person_providers.id+"/show_file_history/"+p.id+""}
                                className="btn btn-xs btn-icon btn-light-secondary">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </a>
                            }
                            {p.person_document_statuses_id != 5 && 
                            <a href={"/document_dossier/"+p.person_providers.id+"/show_file/"+p.id+""}
                                className="btn btn-xs btn-icon btn-light-secondary">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </a>
                            }
                        </td>
                    }
                    { activeTab == 'locals'  &&
                    <td className="text-right">
                        {this.checkImageExtension(p.path) && (
                        <a data-toggle="modal" onClick={() => this.getFileImage(p.id, p.path)} data-target={'#modal' + p.id} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                            <i className="flaticon2-file text-primary icon-sm"></i>
                        </a>
                        )}
                        <a href={'/my_dossiers/file/edit/' +p.id} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                            <i className="flaticon2-edit text-primary"></i>
                        </a>

                        <button className="btn btn-xs btn-icon btn-light-secondary mr-4" onClick={()=>this.handleDelete(p.id)} >
                            <i className="flaticon-delete fw-normal text-primary"></i>
                        </button>

                        <a href={'/my_dossiers/file/download/' +p.id}  className="btn btn-xs btn-icon btn-light-secondary mr-4">
                            <i className="flaticon2-download text-primary"></i>
                        </a>

                        
                    </td>
                    }
                            </tr>
                            }
                        )}
                    </tbody>
                </table>
                {files.total.locals + files.total.files > 10 &&
                    <Pagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={pagination.page}
                    totalFiles={activeTab == "locals" ? files.total.locals : files.total.files}
                    split={10} />
                }
            </div>
                </div>
            </div>
        </div>
		<div className="modal fade" id="visor-modal" tabIndex="-1" role="dialog" aria-labelledby="visor-modal-label" aria-hidden="true">
			<div className="modal-dialog modal-lg" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="visor-modal-label">{lang.get('messages.vista_previa_del_documento')}</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<div id="document-container">
							<iframe id="document-iframe"  className="document-iframe"   frameBorder="0" width="100%" height="600"></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
    </>
    );
  }
}

export default FilePanel;

if (document.getElementById('FilePanel')) {
    ReactDOM.render(<FilePanel />, document.getElementById('FilePanel'));
}
